import ReactDOM from "react-dom"
import { decoder } from "~/components/svgEncode"

const pad = 0

class Replacement extends Component {
  render() {
    const { borderRadius, neuron, layer, width, height } = this.props
    return (
      <img
        width={width}
        height={height}
        style={{ borderRadius }}
        src={neuronFeatureVis("inceptionv1", layer, neuron)}
      />
    )
  }
}

export default class SvgFigure extends Component {
  replaceWithImage = (rect, decoded) => {
    this.replaceWithElement(rect, ({ width, height }) => (
      <Replacement
        height={height}
        width={width}
        borderRadius={+(rect.getAttribute("rx") || 0)}
        {...decoded}
      />
    ))
  }

  replaceWithEl = (rect, el) => {
    const foreignObject = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "foreignObject",
    )

    const attrs = ["x", "y", "width", "height"]

    /*
    attrs.forEach(attr => {
      foreignObject.setAttribute(attr, rect.getAttribute(attr))
    })
    */

    foreignObject.setAttribute("x", +rect.getAttribute("x") - pad)
    foreignObject.setAttribute("width", +rect.getAttribute("width") + pad * 2)

    foreignObject.setAttribute("y", +rect.getAttribute("y") - pad)
    foreignObject.setAttribute("height", +rect.getAttribute("height") + pad * 2)

    rect.replaceWith(foreignObject)
    const div = document.createElement("div")

    foreignObject.appendChild(div)
    const width = +rect.getAttribute("width")
    const height = +rect.getAttribute("height")

    ReactDOM.render(<div>{el({ width, height })}</div>, foreignObject)
  }

  randomStr = () =>
    [...Array(10)].map(i => (~~(Math.random() * 36)).toString(36)).join("")

  onReplace = ref => {
    if (!ref) return
    const { replaceColors = {} } = this.props
    const def = ref.querySelector("defs")
    /*
    if (def) {
      def.remove()
    }
    */

    Object.keys(replaceColors).forEach(color => {
      const target = ref.querySelector(`rect[fill="#${color}"]`)
      if (!target) return
      this.replaceWithEl(target, replaceColors[color])
    })

    Array.from(ref.querySelectorAll(`rect[stroke-opacity="0.01"]`)).forEach(
      rect => {
        this.replaceWithImage(rect, decoder(el.getAttribute("stroke")))
      },
    )
  }

  render() {
    const { children } = this.props

    return (
      <div ref={this.onReplace} style={{ position: "relative" }}>
        {children}
      </div>
    )
  }
}
